import { PubSub } from "@aws-amplify/pubsub";

export const publishToIoT = (serialnumber, msg) => {
  const handlerTopic = "HP/" + serialnumber + "/handler";
  PubSub.publish(handlerTopic, { userChange: msg });
};
